import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Form, Col, Image } from 'react-bootstrap';
import { TbCameraPlus } from "react-icons/tb";
import { FaCamera, FaImages, FaTimes } from 'react-icons/fa';

import { AiTwotoneDelete } from "react-icons/ai";
import { IconButton } from '@mui/material';
import FileTypeErrorModal from '../../layouts/modal/fileTypeErrorModal.js';
import Labels from '../../components/translations/translation.json';
import './ImageUpload.css'; // Add a new CSS file for custom styles


function ImageUpload(props) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const fileInputRef = useRef(null);
    const [isFileUploadClicked,setIsFileUploadClicked] = useState(false);
    const isAndroid = () => /Android/i.test(navigator.userAgent);


   useEffect(() => {
  const handlePopState = (e) => {
    if (isModalOpen) {
      setIsModalOpen(false); // close modal instead of going back
      window.history.pushState(null, '', window.location.href); // push back same state to block actual back
      }
  };

  if (isModalOpen) {
    window.history.pushState(null, '', window.location.href); // add a new history entry
    window.addEventListener('popstate', handlePopState);
  }

  return () => {
    window.removeEventListener('popstate', handlePopState);
  };
}, [isModalOpen]);



      
    const chooseFromGallery = () => {
        setIsFileUploadClicked(true);
                   setTimeout(() => {
                            const inputElement = fileInputRef.current;
        if (inputElement) {

            inputElement.value = ''; // clear old files
            inputElement.removeAttribute('capture');
            inputElement.click();
    
            // Close popup after triggering file picker
            setTimeout(() => {
                setIsModalOpen(false);
            }, 300);
        }

  }, 0);

    };
    
    const useCamera = () => {
        setIsFileUploadClicked(true);

        setTimeout(() => {
                  const inputElement = fileInputRef.current;
        if (inputElement) {
            inputElement.value = ''; // clear old files
            inputElement.setAttribute('capture', 'environment');
            inputElement.click();
            inputElement.removeAttribute('capture');
            // Close popup after triggering file picker
            setTimeout(() => {
                setIsModalOpen(false);
            }, 300);
        }

  }, 0);
    };

   
   
    
    

    const handleImage = (e) => {
        const chosenFiles = Array.from(e.target.files);
        props.callbackfunc(chosenFiles);
        e.target.value = '';
        setIsFileUploadClicked(false); // Reset after handling
    };

    const handleDeleteImages = (index) => {
        props.callbackdeleteImages(index);
    };

    const handleClose = () => {
        props.callbackFileType(false);
    };

    let imagesArray = [];
    if (Array.isArray(props.array)) {
        imagesArray = props.array;
    } else {
        imagesArray = JSON.parse(props.array);
    }

    const handleIconClick =  () => {
      
        if (isAndroid()) {
          setIsFileUploadClicked(false);
          setIsModalOpen(true); // Show custom popup only for Android 14+
        } else {
          setIsFileUploadClicked(true);
           setTimeout(() => {
    fileInputRef.current?.click(); // Safe, minimal delay
  }, 0);
        }
      };
      

    return (
        <Form.Group as={Col} className="form-group">
            <Form.Label className="form-label">{props.label} <span style={{ color: 'red' }}>*</span> :</Form.Label>
            {props.isWiFiAntennAIncident && (
                <Form.Label className="form-label" style={{ marginTop: '8px', fontStyle: 'italic', color: '#25346D' }}>
                    {Labels[props.langCode].WIFI_ANTENNA_LABEL}
                </Form.Label>
            )}

           <label
    htmlFor='icon-button-file'
    className={`upload-label ${props.fileLimit ? 'disabled-label' : ''}`}
    style={{ width: '100%' }}
      onClick={()=>{
       
    }}
    onKeyDown={(e) => {
					if (e.key === 'Enter' || e.key === ' ') {
					  // Trigger same click logic on keyboard
					}
				  }}
>
    <div
    className="filedropper_dropzone"
    tabIndex="0"
    onClick={()=>{
      console.log("filedropper_dropzone clicked")
       if (isAndroid()){
            setIsFileUploadClicked(false);
            setIsModalOpen(true); // Show custom popup only for Android 14+
        }else{
            setIsFileUploadClicked(true);
            fileInputRef.current?.click(); // Safe, minimal delay
        }
    }}
    onKeyDown={(e) => {
					if (e.key === 'Enter' || e.key === ' ') {
					  // Trigger same click logic on keyboard
					}
				  }}
    style={{ pointerEvents: 'none' }} // 🔒 Disables interaction on the whole dropzone
  >
    <div style={{ pointerEvents: 'auto' }}> 
        <IconButton
            onClick={(e) => {
          e.stopPropagation(); // 🛑 Prevents bubbling
        }}
            disabled={props.fileLimit}
            onKeyDown={(e) => {
					if (e.key === 'Enter' || e.key === ' ') {
					  // Trigger same click logic on keyboard
					}
				  }}
        >
            
        <span
  onClick={() => {
    if (!props.fileLimit) {
    }
  }}
  onKeyDown={(e) => {
					if (e.key === 'Enter' || e.key === ' ') {
					  // Trigger same click logic on keyboard
					}
				  }}
  style={{ cursor: props.fileLimit ? 'not-allowed' : 'pointer' }}
>
  <TbCameraPlus
    color={props.fileLimit ? '#ccc' : '#006AB3'}
    size="40"
    onClick={(e) => {
      e.stopPropagation(); // prevent bubbling to IconButton or parent
      if (!props.fileLimit) {
        handleIconClick(); // ✅ ONLY trigger here
      }
    }}
  />
  {isFileUploadClicked && <input
    multiple
    accept="image/*"
    id="icon-button-file"
    type="file"
    ref={fileInputRef}
    onChange={handleImage}
    tabIndex={-1}
    style={{
      display: 'none',
      pointerEvents: 'none',
    }}
  />}
</span>

        </IconButton>
        </div>
    </div>
</label>


            

            {/* Android-style Modal */}
           {isAndroid() && isModalOpen && (
  <div className="android-popup-overlay">
    <div className="android-popup">
      <button className="close-btn" onClick={() => setIsModalOpen(false)}>
        <FaTimes />
      </button>
      <div className="icon-buttons">
        <button className="popup-icon-btn" onClick={useCamera}>
          <FaCamera size={40} color="#006AB3" />
        </button>
        <button className="popup-icon-btn" onClick={chooseFromGallery}>
          <FaImages size={40} color="#006AB3" />
        </button>
      </div>
    </div>
  </div>
)}




            {props.fileLimit && (
                <Form.Label className="form-label-warning">{Labels[props.langCode].MAXIMUM_FILES}</Form.Label>
            )}
            {props.fileType && (
                <FileTypeErrorModal langCode={props.langCode} callback={handleClose} />
            )}

            {imagesArray?.length > 0 &&
                imagesArray.map((imageObj, index) => (
                    <ul className='filedropper_list' key={imageObj.name}>
                        <li className='filedropper_item'>
                            <div className='filedropper_preview'>
                                <Image className="filedropper_img_preview" src={imageObj.base64} alt="" />
                            </div>
                            <div className='filedropper_item-info'>
                                <div className='filedropper_item-name'>
                                    {imageObj.name || '-'}
                                </div>
                            </div>
                            <div className='filedropper_button-zone'>
                                <i
                                    tabIndex="0" 
                                    onKeyDown={(e) => {
					if (e.key === 'Enter' || e.key === ' ') {
					  // Trigger same click logic on keyboard
					}
				  }}
                                    className='filedropper_button-icon'
                                    data-testid="delete-icon"
                                    onClick={() => handleDeleteImages(index)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <AiTwotoneDelete />
                                </i>
                            </div>
                        </li>
                    </ul>
                ))}
        </Form.Group>
    );
}

ImageUpload.propTypes = {
  callbackfunc: PropTypes.func,
  callbackdeleteImages: PropTypes.func,
  callbackFileType: PropTypes.func,
  array: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.string,
  ]),
  label: PropTypes.string,
  isWiFiAntennAIncident: PropTypes.bool,
  fileLimit: PropTypes.bool,
  fileType: PropTypes.bool,
  langCode: PropTypes.string,
};

export default ImageUpload;
